'use client';
import React, { useState } from 'react';
import AppImage from '@/components/ui/AppImage';
import { Play, Info, Star, Clock, Crown } from 'lucide-react';
import PreRollAdOverlay from './PreRollAdOverlay';

const featuredMovie = {
  id: 'movie-001',
  title: 'Dune: Prophecy',
  year: 2024,
  rating: 8.2,
  duration: '2h 26m',
  genre: ['Sci-Fi', 'Aventurë'],
  description:
  'Mijëra vjet para ngjarjeve të Dune, shtëpia Harkonnen nis një luftë për të kontrolluar fatin e universit të njohur njerëzor.',
  poster:
  "https://img.rocket.new/generatedImages/rocket_gen_img_1779618ec-1777464382804.png",
  isPremium: false
};

export default function HeroBanner() {
  const [showAd, setShowAd] = useState(false);

  return (
    <>
      <div className="relative w-full h-[85vh] min-h-[560px] overflow-hidden">
        <AppImage
          src={featuredMovie?.poster}
          alt="Dune: Prophecy — cinematic landscape of a desert planet with twin suns and golden sky"
          fill
          priority
          className="object-cover object-center"
          sizes="100vw" />
        
        <div className="hero-overlay absolute inset-0" />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent" />

        <div className="absolute bottom-0 left-0 right-0 pb-16 px-6 lg:px-8 xl:px-10 2xl:px-16">
          <div className="max-w-screen-2xl mx-auto">
            <div className="max-w-2xl">
              <div className="flex items-center gap-2 mb-4">
                <span className="px-2.5 py-1 bg-primary text-primary-foreground text-xs font-700 rounded-md tracking-wider">
                  FILM I JAVËS
                </span>
                {featuredMovie?.isPremium &&
                <span className="flex items-center gap-1 px-2.5 py-1 bg-accent/20 text-accent text-xs font-700 rounded-md border border-accent/30">
                    <Crown size={11} />
                    PREMIUM
                  </span>
                }
              </div>

              <h1 className="text-hero-xl text-foreground mb-3 drop-shadow-lg">
                {featuredMovie?.title}
              </h1>

              <div className="flex items-center gap-4 mb-4 text-sm text-secondary-foreground">
                <span className="flex items-center gap-1 text-accent font-600">
                  <Star size={14} className="fill-accent" />
                  {featuredMovie?.rating}
                </span>
                <span>{featuredMovie?.year}</span>
                <span className="flex items-center gap-1">
                  <Clock size={13} />
                  {featuredMovie?.duration}
                </span>
                <div className="flex gap-1.5">
                  {featuredMovie?.genre?.map((g) =>
                  <span
                    key={`hero-genre-${g}`}
                    className="px-2 py-0.5 bg-muted text-secondary-foreground text-xs rounded-md border border-border">
                    
                      {g}
                    </span>
                  )}
                </div>
              </div>

              <p className="text-secondary-foreground text-sm leading-relaxed mb-6 line-clamp-2 max-w-lg">
                {featuredMovie?.description}
              </p>

              <div className="flex items-center gap-3">
                <button
                  onClick={() => setShowAd(true)}
                  className="flex items-center gap-2 px-6 py-3 bg-primary text-primary-foreground font-700 rounded-xl hover:bg-primary/90 active:scale-95 transition-all duration-150 shadow-lg shadow-primary/30">
                  
                  <Play size={18} className="fill-primary-foreground" />
                  Luaj Tani
                </button>
                <button className="flex items-center gap-2 px-6 py-3 bg-foreground/10 text-foreground font-600 rounded-xl hover:bg-foreground/20 active:scale-95 transition-all duration-150 backdrop-blur-sm border border-foreground/10">
                  <Info size={18} />
                  Më Shumë
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PreRollAdOverlay open={showAd} onClose={() => setShowAd(false)} movieTitle={featuredMovie?.title} />
    </>);

}